/**
 * Wheel units shared by every layer that turns wheel events into scrolling (CR-W1-15-11): the timeline host
 * (render/timeline/axis.ts), the keymap's wheel chords (app/registry/chords.ts) and the lane's fine-tuning. One
 * physical notch (Firefox mouse wheels report 3 lines of deltaMode 1) must scroll the same amount whichever handles
 * it. Pure; no DOM types.
 */

/** Normalised CSS px per wheel "line" (deltaMode 1). */
export const WHEEL_LINE_PX = 40;
/** CSS px of one wheel notch (100 px per notch, the step of `notches`, scroll beats and zoom). */
export const WHEEL_NOTCH_PX = 100;

/** The deltas of a wheel event. */
export interface WheelDeltas {
  readonly deltaX: number;
  readonly deltaY: number;
  /** 0 pixels, 1 lines, 2 pages. */
  readonly deltaMode: number;
}

/** Wheel deltas in CSS px whatever the deltaMode; a page is `pagePx` (at least 1); non-finite deltas count as 0. */
export function wheelDeltaPx(e: WheelDeltas, pagePx: number): { readonly dx: number; readonly dy: number } {
  const k = e.deltaMode === 1 ? WHEEL_LINE_PX : e.deltaMode === 2 ? Math.max(1, pagePx) : 1;
  const finite = (v: number): number => (Number.isFinite(v) ? v : 0);
  return { dx: finite(e.deltaX) * k, dy: finite(e.deltaY) * k };
}
